export default __webpack_public_path__ + "static/media/port.cf64c741.jpeg";